import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModerationReportContextType } from '../../common/moderationTypes';
import { LoadableModerationReportModal } from './moderation/LoadableModerationReportModal';
import { useModerationReportingEnabled } from './moderation/useModerationReportingEnabled';

function detectContextType(pathname: string): ModerationReportContextType {
  if (/\/characters?\//i.test(pathname)) {
    return ModerationReportContextType.CHARACTER_PROFILE;
  }
  if (/\/guilds?\//i.test(pathname)) {
    return ModerationReportContextType.GUILD_PROFILE;
  }
  if (/\/mythic-plus\/runs/i.test(pathname) || /\/season.*runs/i.test(pathname)) {
    return ModerationReportContextType.KEYSTONE_RUN;
  }
  if (/\/recruitment/i.test(pathname)) {
    return ModerationReportContextType.RECRUITMENT_LISTING;
  }
  return ModerationReportContextType.OTHER;
}

export function ErrorFallbackPage() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const canReport = useModerationReportingEnabled();

  const contextType = typeof window !== 'undefined'
    ? detectContextType(window.location.pathname)
    : ModerationReportContextType.OTHER;

  return (
    <div style={{ textAlign: 'center', padding: '60px 20px' }}>
      <div style={{ fontSize: 48, marginBottom: 16, color: '#f39c12' }}>
        <i className="fa fa-exclamation-triangle" />
      </div>
      <h1 style={{ fontSize: 24, marginBottom: 8, color: '#fff' }}>{t('common:errors.something-went-wrong')}</h1>
      <p style={{ fontSize: 14, color: '#999', marginBottom: 24 }}>
        {t('common:errors.unexpected-error', { defaultValue: 'An unexpected error occurred.' })}
      </p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
        <button type="button" className="slds-button slds-button--neutral" onClick={() => window.history.back()}>
          <i className="fa fa-arrow-left slds-m-right--x-small" />
          {t('common:actions.go-back', { defaultValue: 'Go Back' })}
        </button>
        {canReport && (
          <button type="button" className="slds-button slds-button--brand" onClick={() => setIsModalOpen(true)}>
            <i className="fa fa-flag slds-m-right--x-small" />
            {t('moderation:button.report')}
          </button>
        )}
      </div>
      {canReport && isModalOpen && (
        <LoadableModerationReportModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          contextType={contextType}
          entityId={0}
        />
      )}
    </div>
  );
}
